<template>
  <div>
    <div class="am-petty-cash-main">
      <div class="am-header am-main-top-box">
        <div class="am-title am-main-top-box-title">{{pettyCash.title}}</div>
      </div>
      <table class="am-petty-cash-table">
        <tbody>
        <tr>
          <td class="am-petty-cash-label"><span><strong>Starting Petty Cash</strong></span>:</td>
          <td v-if="pettyCash.pettyCashType !== 'end' && pettyCash.pettyCashType !== 'endOther'">
            <money class="input-petty-cash" v-model="pettyCash.startingAmount" v-bind="money"></money>
          </td>
          <td v-else class="am-petty-cash-disabled-money">$ {{Number(pettyCash.startingAmount).toFixed(2)}}</td>
        </tr>
        <tr v-if="pettyCash.pettyCashType === 'end' || pettyCash.pettyCashType === 'endOther'">
          <td class="am-petty-cash-label"><span><strong>Ending Petty Cash</strong></span>:</td>
          <td>
            <money class="input-petty-cash" v-model="pettyCash.endingAmount" v-bind="money"></money>
          </td>
        </tr>
        <tr  v-if="pettyCash.pettyCashType === 'end' || pettyCash.pettyCashType === 'endOther'">
          <td class="am-petty-cash-label"><span><strong>{{differenceTitle}}</strong></span>:</td>
          <td class="am-petty-cash-disabled-money">$ {{Number(pettyCash.difference).toFixed(2)}}</td>
        </tr>
        <tr>
          <td class="am-petty-cash-label"><span><strong>Reason</strong></span>: <span v-if="differenceTitle !== 'Difference' && (pettyCash.pettyCashType === 'end' || pettyCash.pettyCashType === 'endOther')" class="am-asterisk-validation">&nbsp;*</span></td>
          <td>
            <textarea rows="4" class="reason-petty-cash" maxlength="500" v-model="reason"></textarea>
          </td>
        </tr>
        </tbody>
      </table>
      <hr class="am-petty-cash-line">
      <div class="am-petty-cash-footer">
        <div class="am-blue-border">
          <button type="button" class="btn btn-primary am-petty-cash-button-float-right" @click="submit()" :disabled="isSubmitDisabled"><span :title="submitTitle">Submit</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from './../http'
  import config from './../config/global.config'

  export default {
    data: function () {
      return {
        name: 'PettyCash',
        reason: '',
        differenceTitle: 'Shortage',
        submitTitle: '',
        isSubmitDisabled: false,
        pettyCash: {
          pettyCashType: '',
          startingAmount: 0,
          endingAmount: 0,
          difference: 0,
          startingReason: '',
          endingReason: '',
          title: ''
        },
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '$ ',
          masked: false
        }
      }
    },
    props: {
      pettyCashType: {
        type: String,
        required: true
      }
    },
    mounted () {
      this.$modal.show('display-petty-cash')
      this.checkTitle()
      this.initializePettyCash()
      this.calculateDifference()
    },

    watch: {
      'pettyCash.endingAmount': function () {
        this.pettyCash.endingAmount = Math.abs(this.pettyCash.endingAmount);
        this.calculateDifference()
      },
      'pettyCash.startingAmount': function () {
        this.pettyCash.startingAmount = Math.abs(this.pettyCash.startingAmount)
        this.calculateDifference()
      },
      'reason': function () {
        this.checkReason()
      }
    },

    methods : {
      checkTitle() {
        this.pettyCash.pettyCashType = this.pettyCashType
        if(this.pettyCash.pettyCashType === 'end' || this.pettyCash.pettyCashType === 'endOther') {
          this.pettyCash.title = 'Ending Petty Cash'
          return this
        } else {
          this.pettyCash.title = 'Starting Petty Cash'
          return this
        }
      },

      initializePettyCash() {
        let self = this
          api.makeRequest('/employee/petty-cash/list').then(
            (data) => {
              let pettyCashData = data.data.results
              if(self.pettyCash.pettyCashType === 'end' || self.pettyCash.pettyCashType === 'endOther'){
                self.pettyCash.startingAmount = typeof(pettyCashData.startingAmount) != 'undefined' ? pettyCashData.startingAmount : 0
                return self
              } else {
                self.pettyCash.startingAmount = typeof(pettyCashData.endingAmount) != 'undefined' ? pettyCashData.endingAmount : 0
                return self
              }
            }
          )
      },

      calculateDifference() {
        if(this.pettyCash.pettyCashType !== 'end' && this.pettyCash.pettyCashType !== 'endOther') {
          return this
        }
        let difference = Math.abs(this.pettyCash.endingAmount) - Math.abs(this.pettyCash.startingAmount)
        if (difference > 0) {
          this.differenceTitle = 'Overage'
        } else if(difference < 0) {
          this.differenceTitle = 'Shortage'
        } else {
          this.differenceTitle = 'Difference'
        }
        this.checkReason()
        this.pettyCash.difference = Math.abs(difference)
        return this
      },

      checkReason() {
        if(this.reason.trim() === "" && this.differenceTitle !== 'Difference' && (this.pettyCash.pettyCashType === 'end' || this.pettyCash.pettyCashType === 'endOther')) {
          this.submitTitle = 'Reason Required'
          this.isSubmitDisabled = true
        } else {
          this.submitTitle = ''
          this.isSubmitDisabled = false
        }
      },

      closeModal() {
        this.$store.dispatch('events/fireEvent', { name: 'close-petty-cash', data: null})
        if (this.pettyCash.pettyCashType === 'end'){
          window.location.href = '/logout.php'
        } else if(this.pettyCash.pettyCashType === 'start'){
          location.reload()
        }
      },

      submit() {
        let self = this
        if(self.pettyCash.pettyCashType === 'end' || self.pettyCash.pettyCashType === 'endOther'){
          self.pettyCash.endingReason = self.reason.trim()
          api.postRequest('employee/petty-cash/update', self.pettyCash)
        } else {
          self.pettyCash.startingReason = self.reason.trim()
          api.postRequest('employee/petty-cash/create', self.pettyCash)
        }
        self.closeModal()
      }
    }
  }
</script>

<style>
  .am-petty-cash-main {
    background: white;
  }

  .am-header {
    height: 35px;
  }

  .am-title {
    font-size: 12px;
    font-weight: bold;
    float: left;
    padding: 8px 8px 8px 15px;
  }

  .am-header-icons a {
    padding-right: 5px;
  }


  .am-finance-table tbody tr:nth-child(odd) {
    background-color: #ECECEC;
  }

  .am-finance-table tbody tr:nth-child(even) {
    background-color: #F4F4F4;
  }

  .am-finance-table thead {
    background-color: #444444;
    color: white;
  }

  .am-finance-table thead tr {
    height: 20px;
  }

  .am-finance-table th {
    font-size: 11px;
  }

  .am-finance-table td {
    font-size: 11px;
  }

  .input-petty-cash {
    float: left;
    height: 30px;
    width: 100px;
    font-size: 11px;
    padding: 10px 0 10px 5px;
    background: white;
    margin-bottom: 5px;
    margin-top: 5px;
  }

  .am-petty-cash-table {
    padding: 10px 10px 10px 10px;
    background: white;
  }

  .am-petty-cash-button-float-right {
    margin-left: 350px;
    height: 25px;
    padding: 4px 10px;
    font-size: 12px;
  }

  .reason-petty-cash {
    float: left;
    width: 200px;
    max-width: 235px;
    min-width: 100px;
    max-height: 350px;
    font-size: 11px;
    padding: 10px 1px 10px 10px;
    background: white;
  }

  .am-petty-cash-label {
    float: right;
    height: 20px;
    width: 200px;
    font-size: 11px;
    padding: 10px 1px 10px 20px;
  }

  .am-petty-cash-line {
    width: 100%;
    border-top: 1px solid #4297d7;
    margin: 8px 0 8px 0;
  }

  .am-petty-cash-disabled-money {
    font-size: 11px;
    padding: 10px 0 10px 5px;
  }

  .am-asterisk-validation {
    color: #ff0000;
    font-weight: 700;
    font-size: 16px;
  }

  .am-petty-cash-footer {
    padding: 1px 1px 6px 10px;
    background: white;
  }
</style>
